import { takeLatest } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import { fetchHistoryData } from '../actions';
import { workerFetchHistory } from './workers';

export default function* watchHistory(): SagaIterator {
  yield takeLatest(fetchHistoryData, workerFetchHistory);
}
